import { shorten } from '@polaris/core/utils'
import { useAtomValue, useSetAtom } from 'jotai'
import { TriangleAlert } from 'lucide-react'
import { invalidWalletKeyringAtom } from '@/src/stores/route-machine/atoms'
import {
  openSelectWalletsDialog,
  selectWalletsDialogAtom,
} from '@/src/stores/select-wallets'
import { cn } from '@/src/utils/styles'
import { DismissButton } from '../trade-overview/actions-buttons'
import { Button } from '../ui/button'
import CopyButton from '../ui/copy-button'

export default function WalletError() {
  const missingWalletInfo = useAtomValue(invalidWalletKeyringAtom)
  const setDialogState = useSetAtom(selectWalletsDialogAtom)

  return (
    <div className='flex flex-col justify-between p-5 bg-foreground rounded-3xl max-w-[384px] min-h-[496px]'>
      <div
        className={cn('flex flex-col py-[54px]', {
          'py-6': missingWalletInfo?.isDisconnected,
        })}
      >
        <div className='flex items-center justify-center py-6'>
          <div className='flex items-center justify-center size-16 rounded-full bg-danger'>
            <TriangleAlert
              width={32}
              height={32}
              className='size-8 text-danger-text'
            />
          </div>
        </div>
        <h1 className='text-xl font-semibold text-primary text-center'>
          {missingWalletInfo?.isDisconnected
            ? 'Wallet disconnected'
            : 'Wallet account changed'}
        </h1>
        <span className='text-secondary text-center py-3'>
          Reconnect your wallet with the account that started this trade.
        </span>
        {missingWalletInfo?.requiredAddress && (
          <div className='flex items-center justify-between gap-3 px-3 py-2 my-3 border border-border1 rounded-xl w-full'>
            <span className='text-secondary text-sm'>Account address</span>

            <CopyButton
              contentToCopy={missingWalletInfo.requiredAddress}
              displayContent={shorten(missingWalletInfo.requiredAddress)}
            />
          </div>
        )}
      </div>
      <div className='flex flex-col gap-3 pt-3'>
        {missingWalletInfo?.isDisconnected && (
          <Button
            type='button'
            onClick={() => setDialogState(openSelectWalletsDialog())}
            variant='primary'
            className='w-full'
          >
            Connect wallet
          </Button>
        )}
        <DismissButton type='button' size='md'>
          Cancel
        </DismissButton>
      </div>
    </div>
  )
}
